import { FeatureFlags } from '@kindo/universal';
import { useFlag } from '@unleash/nextjs';

import { CodeSandboxSetting } from './CodeSandboxSetting';
import { OrgInfoAndUsers } from './OrgInfoAndUsers';

import { useCanAccessSecuritySettings } from '~/hooks';

const OrgMemberSettings = () => {
  const canUseCodeSandbox = useFlag(FeatureFlags.CODE_SANDBOX);

  const { userCanManageOrganization } = useCanAccessSecuritySettings();

  const canChangeCodeSandboxSetting =
    canUseCodeSandbox && userCanManageOrganization;
  return (
    <div
      className="mb-2 flex h-full flex-col gap-4"
      data-testid="org-member-settings-container"
    >
      <OrgInfoAndUsers />
      {canChangeCodeSandboxSetting && <CodeSandboxSetting />}
    </div>
  );
};
export default OrgMemberSettings;
